export default "__VITE_ASSET__BXIpuAiH__"